import { useContext } from 'react'
import CartContext from '../../store/cart-context'
import Modal from '../UI/Modal'
import classes from './Cart.module.css'
import CartItem from './CartItem'


const Cart = props => {
    const cartCtx = useContext(CartContext)

    const totalAmount = `$${cartCtx.totalAmount.toFixed(2)}`
    const hasItem = cartCtx.items.length > 0;
    const cartItemRemoverHandler = id => {
        cartCtx.removeItem(id)
    }
    const cartItemAddHandler = item => {
        cartCtx.addItem({...item,amount: 1});
    }

    const cartitems = <ul className={classes['cart-items']}>{cartCtx.items.map((item)=>(<CartItem key = {item.id} name={item.name} amount={item.amount} price = {item.price}
    onRemove = {cartItemRemoverHandler.bind(null,item.id)}
    onAdd = {cartItemAddHandler.bind(null,item)}
     />))}</ul>
    return (
        <Modal onClose={props.onClose}>
              {cartitems}
            <div className={classes.total}>
                    <span>Total Amount</span>
                    <span>{totalAmount}</span>
            </div>
            <div className={classes.actions}>
                <button className={classes['button--alt']} onClick={props.onClose}>Close</button>
                {hasItem? <button className={classes['button--alt']}>Order</button>:""}
            </div>
        
        </Modal>
           
    )
}

export default Cart